import React, { useEffect, useState, useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { Card } from "primereact/card";
const metodosPago = [
  { label: 'Efectivo', value: 'efectivo' },
  { label: 'Transferencia', value: 'transferencia' },
  { label: 'Tarjeta', value: 'tarjeta' }
];

const Pagos = () => {
  const [matricula, setMatricula] = useState('');
  const [alumno, setAlumno] = useState(null);
  const [cargos, setCargos] = useState([]);
  const [selected, setSelected] = useState([]);
  const [metodo, setMetodo] = useState('efectivo');
  const [loading, setLoading] = useState(false);
const axiosPrivate = useAxiosPrivate();
  // 🔹 cargar cargos por alumno
  const buscar = async () => {
    if (!matricula) return;
    setLoading(true);
    try {
      const res = await axiosPrivate.get(`CEUM/cargos/${matricula}`);

      // inicializamos campo pagar
      const data = res.data.map(r => ({ ...r, pagar: 0 }));

      setCargos(data);
      setAlumno({ nombre: 'Alumno', matricula }); // aquí puedes integrar tu endpoint real de alumno
      setSelected([]);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 cambiar monto a pagar
  const onChangeMonto = (rowData, value) => {
    const updated = cargos.map(r =>
      r.id === rowData.id ? { ...r, pagar: value || 0 } : r
    );
    setCargos(updated);
  };

  // 🔹 total dinámico
  const total = useMemo(() => {
    return selected.reduce((acc, r) => acc + (r.pagar || 0), 0);
  }, [selected]);

  // 🔹 seleccionar fila → por default llena pagar con saldo
  const onSelectionChange = (e) => {
    const selectedRows = e.value.map(r => ({
      ...r,
      pagar: r.pagar && r.pagar > 0 ? r.pagar : r.saldo
    }));

    // sincronizar en lista principal
    const updated = cargos.map(r => {
      const found = selectedRows.find(s => s.id === r.id);
      return found ? { ...r, pagar: found.pagar } : r;
    });

    setCargos(updated);
    setSelected(selectedRows);
  };

  // 🔹 registrar pago
  const registrarPago = async () => {
    if (selected.length === 0) {
      alert('Selecciona al menos un cargo');
      return;
    }

    try {
      await axiosPrivate.post('CEUM/pagos', {
        matricula,
        metodo_pago: metodo,
        items: selected.map(r => ({
          id_cargo: r.id,
          monto: r.pagar || r.saldo
        }))
      });

      alert('Pago registrado correctamente');
      buscar();

    } catch (error) {
      console.error(error);
      alert('Error al registrar pago');
    }
  };

  const money = (v) => `$ ${Number(v || 0).toFixed(2)}`;

  return (
        <Card className="card" title='Registro de pagos'>

      {/* 🔍 Buscador */}
      <div className="flex gap-2 mb-3">
        <InputText
          value={matricula}
          onChange={(e) => setMatricula(e.target.value)}
          placeholder="Matrícula"
        />
        <Button label="Buscar" icon="pi pi-search" onClick={buscar} loading={loading} />
      </div>

      {/* 👤 Alumno */}
      {alumno && (
        <div className="mb-3">
          <strong>{alumno.nombre}</strong> ({alumno.matricula})
        </div>
      )}

      {/* 💳 Método */}
      <div className="mb-3" style={{ maxWidth: '250px' }}>
        <label>Método de pago</label>
        <Dropdown
          value={metodo}
          options={metodosPago}
          onChange={(e) => setMetodo(e.value)}
        />
      </div>

      {/* 📊 Tabla */}
      <DataTable
        value={cargos}
        selection={selected}
        onSelectionChange={onSelectionChange}
        dataKey="id"
        paginator rows={10}
        className="p-datatable-sm"
      >
        <Column selectionMode="multiple" style={{ width: '3rem' }} />

        <Column field="concepto" header="Concepto" />
        <Column field="periodo" header="Periodo" />
        <Column field="fecha_vencimiento" header="Vencimiento" />

        <Column
          header="Saldo"
          body={(row) => money(row.saldo)}
        />

        <Column
          header="Pagar"
          body={(row) => (
            <InputNumber
              value={row.pagar}
              onValueChange={(e) => onChangeMonto(row, e.value)}
              mode="currency"
              currency="MXN"
              min={0}
              max={row.saldo}
            />
          )}
        />

        <Column field="estatus" header="Estatus" />
      </DataTable>

      {/* 💰 Totales */}
      <div className="flex justify-content-end mt-3">
        <h3>Total: {money(total)}</h3>
      </div>

      {/* 🚀 Acciones */}
      <div className="flex justify-content-end mt-3 gap-2">
        <Button label="Cancelar" className="p-button-text" onClick={() => setSelected([])} />
        <Button label="Registrar Pago" icon="pi pi-check" onClick={registrarPago} />
      </div>

    </Card>
  );
};

export default Pagos;
